module.exports = __webpack_public_path__ + "media/images/gallery/pn_tab_on-94499161adbd92430e7a0ef1ee32d7a0.jpg";